import { render, staticRenderFns } from "./BoostBuffetOrPartyEventTag.vue?vue&type=template&id=28234d2e&"
import script from "./BoostBuffetOrPartyEventTag.vue?vue&type=script&lang=js&"
export * from "./BoostBuffetOrPartyEventTag.vue?vue&type=script&lang=js&"
import style0 from "./BoostBuffetOrPartyEventTag.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28234d2e')) {
      api.createRecord('28234d2e', component.options)
    } else {
      api.reload('28234d2e', component.options)
    }
    module.hot.accept("./BoostBuffetOrPartyEventTag.vue?vue&type=template&id=28234d2e&", function () {
      api.rerender('28234d2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BoostBuffetOrPartyEventTag.vue"
export default component.exports